import React, { useRef, useEffect, useState } from "react";
import { ChatForm } from "./ChatForm";
import ChatMessage from "./ChatMessage";
import PresenceIcon from "./PresenceIcon";
import { UserControls } from "./UserControls";
import { RoomControls } from "./RoomControls";
import { LockControls } from "./LockControls";
import { ControlToolbar } from "./ControlToolbar";
import { ProgressBar } from "./ProgressBar";
import { VideoChat } from "./VideoChat";

import { connect } from "react-redux";
import { changeUser, logout } from "../redux/actions";
import { selectCanSeeControls } from "../redux/selectors.js";
import { faVideo } from "@fortawesome/free-solid-svg-icons";
import IconButton from "./IconButton";
import styled from "styled-components";


const VideoChatContainerDiv=styled.div`
	max-height: 60%;
	overflow: scroll;
`;

const PureChatBox = (props) => {

	const scrollRef = useRef(null);
	const [videoChatEnabled, setVideoChatEnabled] = useState(false);

	useEffect(() => {
		if (scrollRef) {
			scrollRef.current.scrollIntoView(false, { behavior: "smooth", block: "end" });
		}
	});

	const renderChats = () => {
		if (!props.chats) { return null; }
		return (props.chats.map(c => <ChatMessage key={c.timestamp} chat={c} />));
	};

	/* Quick hack for summer house */
	const showVideoChatIcon = () => {
		return (!["WEDSWATCHPARTY", "WATCHIT"].includes(props.room_key.toUpperCase()));
	};

	const renderControlToolbar = () => {
		if (props.canSeeControls) {
			return (<ControlToolbar controls={<><UserControls /><LockControls /><RoomControls /></>} progressBar={<ProgressBar />} />);
		} else {
			return (<ControlToolbar controls={<><UserControls /><LockControls /></>} progressBar={null} />);
		}
	};

	return (
		<div style={{ height: "100%", display: "flex", flexDirection: "column" }}>

			<div style={{ flexGrow: 0 }}>
				{ showVideoChatIcon() ? 
					<IconButton title="Toggle video chat" key="videochat" icon={faVideo} highlighted={videoChatEnabled} onClick={()=>(setVideoChatEnabled(!videoChatEnabled))}>Toggle video chat</IconButton>
					:
					""
				}
				{props.room_key}
				{props.present.map((p) => (<PresenceIcon key={p.connection_id} nick_name={p.client_id} />))}
			</div>
			{videoChatEnabled ?
				<VideoChatContainerDiv>
					<VideoChat nickName={props.nick_name} roomKey={props.room_key}/>
				</VideoChatContainerDiv>
				:
				null
			}
			<div style={{ flexGrow: 100, overflowY: "scroll", overflowWrap: "anywhere" }}>
				{renderChats()}
				<div ref={scrollRef} />
			</div>
			<div className="chat-container" style={{ flexGrow: 0 }}>
				<ChatForm />
			</div>
			<div style={{ flexGrow: 0 }}>
				{props.view_mode === "chat" ? renderControlToolbar() : null}
			</div>
		</div>

	);
}

const mapStateToProps = state => ({
	room_key: state.user.room_key,
	nick_name: state.user.nick_name,
	view_mode: state.user.view_mode,
	chats: state.chats,
	present: state.present,
	canSeeControls: selectCanSeeControls(state),
});
export const ChatBox = connect(mapStateToProps, { changeUser, logout })(PureChatBox);

